import React from "react";
import WhyChooseUs from "../UI/WhyChooseUs";

const WhyChooseUsWalk = () => {
  const features = [
    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FWalkthrough%2Fwhy_choose_us%2FMarketing_and_Client_Presentations.png?alt=media&token=8a568166-ab7e-4cf8-b4d7-c4cdd43f0f31",
      title: "Marketing & Client Presentations",
      description: "",
    },

    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FWalkthrough%2Fwhy_choose_us%2FCost_Effective_Revisions.png?alt=media&token=4888f02d-f09d-4925-9b4e-770cfa1a0603",
      title: "Cost-Effective Revisions",
      description: "",
    },

    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FWalkthrough%2Fwhy_choose_us%2FInteractive_Virtual_Tour.png?alt=media&token=a445661d-0dab-4cdf-bde4-12b51d67da31",
      title: "Interactive Virtual Tour",
      description: "",
    },
    {
      icon:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FWalkthrough%2Fwhy_choose_us%2FDetailed_Interiors_Exteriors.png?alt=media&token=6e7f9d3d-6df3-4f79-96e5-ee746f667708",
      title: "Detailed Interiors & Exteriors",
      description: "",
    },

    {
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2FWalkthrough%2Fwhy_choose_us%2FRealistic_3D_Visualization.png?alt=media&token=04ba0c70-4b3a-41f1-8017-be2c44727c91",
      title: "Realistic 3D Visualization",
      description: "",
    },
  ];

  return (
    <>
      <WhyChooseUs features={features} />
    </>
  );
};

export default WhyChooseUsWalk;
